export enum PaymentTypes {
	LYDIA = 'lydia',
	CARD = 'cb',
	XPAY = 'cko_flow',
	XPAY_GOOGLE = 'cko_flow_google',
	XPAY_APPLE = 'cko_flow_apple',
	TRANSFER = 'transfer'
}

export const isXpayType = (paymentType: PaymentTypes): boolean =>
	paymentType === PaymentTypes.XPAY ||
	paymentType === PaymentTypes.XPAY_GOOGLE ||
	paymentType === PaymentTypes.XPAY_APPLE

export const toBackendPaymentType = (paymentType: PaymentTypes): string =>
	isXpayType(paymentType) ? PaymentTypes.XPAY : paymentType

export enum PaymentSources {
	MONEY_POT = 'money_pot',
	LYDIA_PAGE = 'lydia_page'
}
